module.exports = __webpack_public_path__ + "static/media/Maji_ar.e48ce794.gif";